const KB = "taxCalculator.pphFinal42.knowledgeBase";

export const PPH_FINAL_42_KB_KEYS = {
  title: `${KB}.title`,
  subtitle: `${KB}.subtitle`,
  sections: [
    {
      type: "intro",
      parts: [
        { text: `${KB}.introPart1` },
        { text: `${KB}.introHighlight`, bold: true },
        { text: `${KB}.introPart2` },
      ],
    },
    {
      type: "text",
      title: `${KB}.whatIs.title`,
      description: `${KB}.whatIs.description`,
    },
    {
      type: "list",
      title: `${KB}.objects.title`,
      description: `${KB}.objects.description`,
      items: [
        `${KB}.objects.item1`,
        `${KB}.objects.item2`,
        `${KB}.objects.item3`,
        `${KB}.objects.item4`,
        `${KB}.objects.item5`,
        `${KB}.objects.item6`,
        `${KB}.objects.item7`,
        `${KB}.objects.item8`,
        `${KB}.objects.item9`,
        `${KB}.objects.item10`,
      ],
    },
    {
      type: "text",
      title: `${KB}.umkm.title`,
      descriptions: [
        `${KB}.umkm.description1`,
        `${KB}.umkm.description2`,
        `${KB}.umkm.description3`,
      ],
    },
    {
      type: "table",
      title: `${KB}.constructionRates.title`,
      description: `${KB}.constructionRates.description`,
      headers: [
        `${KB}.constructionRates.headerType`,
        `${KB}.constructionRates.headerQualification`,
        `${KB}.constructionRates.headerRate`,
      ],
      rows: [
        {
          cells: [
            { key: `${KB}.constructionRates.pelaksanaKecil` },
            { key: `${KB}.constructionRates.withSBU` },
            { value: "1,75%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.pelaksanaKecil` },
            { key: `${KB}.constructionRates.withoutSBU` },
            { value: "4%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.pelaksanaMenengahBesar` },
            { key: `${KB}.constructionRates.withSBU` },
            { value: "2,65%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.pelaksanaMenengahBesar` },
            { key: `${KB}.constructionRates.withoutSBU` },
            { value: "3,5%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.perencana` },
            { key: `${KB}.constructionRates.withSBU` },
            { value: "3,5%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.perencana` },
            { key: `${KB}.constructionRates.withoutSBU` },
            { value: "6%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.terintegrasi` },
            { key: `${KB}.constructionRates.withSBU` },
            { value: "4%" },
          ],
        },
        {
          cells: [
            { key: `${KB}.constructionRates.terintegrasi` },
            { key: `${KB}.constructionRates.withoutSBU` },
            { value: "5%" },
          ],
        },
      ],
    },
    {
      type: "table",
      title: `${KB}.ratesAndThresholds.title`,
      description: `${KB}.ratesAndThresholds.description`,
      headers: [
        `${KB}.ratesAndThresholds.headerObject`,
        `${KB}.ratesAndThresholds.headerRate`,
        `${KB}.ratesAndThresholds.headerThreshold`,
      ],
      rows: [
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.umkm` },
            { value: "0,5%" },
            { key: `${KB}.ratesAndThresholds.umkmThreshold` },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.bungaDeposito` },
            { value: "20%" },
            { value: "Rp7.500.000" },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.bungaKoperasi` },
            { value: "10% (final)" },
            { value: "Rp240.000/bulan" },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.bungaObligasi` },
            { value: "10-15%" },
            { value: "-" },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.hadiahUndian` },
            { value: "25%" },
            { value: "-" },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.transaksiSaham` },
            { value: "0,1%" },
            { value: "-" },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.sewaTanah` },
            { value: "10%" },
            { value: "-" },
          ],
        },
        {
          cells: [
            { key: `${KB}.ratesAndThresholds.pengalihanTanah` },
            { value: "2,5% / 1%" },
            { value: "-" },
          ],
        },
      ],
    },
    {
      type: "text",
      title: `${KB}.finalNature.title`,
      descriptions: [
        `${KB}.finalNature.description1`,
        `${KB}.finalNature.description2`,
      ],
    },
    {
      type: "list",
      title: `${KB}.legalBasis.title`,
      items: [
        `${KB}.legalBasis.item1`,
        `${KB}.legalBasis.item2`,
        `${KB}.legalBasis.item3`,
        `${KB}.legalBasis.item4`,
        `${KB}.legalBasis.item5`,
        `${KB}.legalBasis.item6`,
      ],
    },
  ],
};
